var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#ED4C5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8889H23M16.125 15.7778V20.1111M18.875 15.7778V20.1111M12.6875 12.8889L13.375 21.5556C13.375 21.9386 13.5199 22.306 13.7777 22.5769C14.0356 22.8478 14.3853 23 14.75 23H20.25C20.6147 23 20.9644 22.8478 21.2223 22.5769C21.4801 22.306 21.625 21.9386 21.625 21.5556L22.3125 12.8889M15.4375 12.8889V10.7222C15.4375 10.5307 15.5099 10.347 15.6389 10.2115C15.7678 10.0761 15.9427 10 16.125 10H18.875C19.0573 10 19.2322 10.0761 19.3611 10.2115C19.4901 10.347 19.5625 10.5307 19.5625 10.7222V12.8889",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.b67bc53437bb4c57725ed9d337569010.svg";
export { ForwardRef as ReactComponent };